'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    AppUserResource = _require2.AppUserResource;

module.exports.AppUser = function (_BaseEntity) {
  _inherits(AppUser, _BaseEntity);

  _createClass(AppUser, null, [{
    key: '__name__',
    value: function __name__() {
      return 'appuser';
    }
  }]);

  function AppUser(data) {
    _classCallCheck(this, AppUser);

    var _this = _possibleConstructorReturn(this, (AppUser.__proto__ || Object.getPrototypeOf(AppUser)).call(this));

    _this._entityName = 'de.ul.fob.security.AppUser';
    _this.dn = 'N_N'; // Set when app user is generated manually
    _this.email = null;
    _this.enabled = true; // Set when app user is generated manually
    _this.forscher = false;
    _this.lastLogin = null;
    _this.userName = null;

    _this.appUser = null;
    _this.applicationRoles = null;
    _this.organisationseinheiten = null;
    _this.zstzlOrganisationseinheiten = null;
    _get(AppUser.prototype.__proto__ || Object.getPrototypeOf(AppUser.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(AppUser, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'dn', 'email', 'enabled', 'lastLogin', 'userName', 'forscher'],
        links: ['appUser', 'applicationRoles', 'organisationseinheiten', 'zstzlOrganisationseinheiten']
      });
    }
  }, {
    key: 'fetchAppUser',
    value: function fetchAppUser() {
      return _get(AppUser.prototype.__proto__ || Object.getPrototypeOf(AppUser.prototype), 'genericResolve', this).call(this, 'appUser');
    }
  }, {
    key: 'fetchApplicationRoles',
    value: function fetchApplicationRoles() {
      return _get(AppUser.prototype.__proto__ || Object.getPrototypeOf(AppUser.prototype), 'genericResolve', this).call(this, 'applicationRoles');
    }
  }, {
    key: 'fetchOrganisationseinheiten',
    value: function fetchOrganisationseinheiten() {
      return _get(AppUser.prototype.__proto__ || Object.getPrototypeOf(AppUser.prototype), 'genericResolve', this).call(this, 'organisationseinheiten');
    }
  }, {
    key: 'fetchZstzlOrganisationseinheiten',
    value: function fetchZstzlOrganisationseinheiten() {
      return _get(AppUser.prototype.__proto__ || Object.getPrototypeOf(AppUser.prototype), 'genericResolve', this).call(this, 'zstzlOrganisationseinheiten');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(AppUser.prototype.__proto__ || Object.getPrototypeOf(AppUser.prototype), 'genericResolve', this).call(this, 'appUser'), _get(AppUser.prototype.__proto__ || Object.getPrototypeOf(AppUser.prototype), 'genericResolve', this).call(this, 'applicationRoles'), _get(AppUser.prototype.__proto__ || Object.getPrototypeOf(AppUser.prototype), 'genericResolve', this).call(this, 'organisationseinheiten'), _get(AppUser.prototype.__proto__ || Object.getPrototypeOf(AppUser.prototype), 'genericResolve', this).call(this, 'zstzlOrganisationseinheiten')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof AppUserResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(AppUser.prototype.__proto__ || Object.getPrototypeOf(AppUser.prototype), 'fetchQuery', this).call(this, AppUserResource);
      }
    }
  }]);

  return AppUser;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/appUser.js
// module id = 6bG4
// module chunks = 0